require('./userProfileDirective/userProfileDirective');
require('./userProfileController');

"use strict";

angular.module('app.userProfile', [
    'app.userProfile.userProfileDirective',
    'app.userProfile.userProfileController'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider
                .state('app.userProfile', {
                    url: '/profiles/:username',
                    abstract: true,
                    templateUrl: 'components/userProfile/userProfileView.html',
                    controller: 'app.userProfile.userProfileController',
                    title: 'User Profile',
                    resolve: {
                        username: [
                            '$stateParams', function ($stateParams) {
                                return $stateParams.username;
                            }
                        ]
                    }
                })
                .state('app.userProfile.feed', {
                    url: '',
                    underTitle: 'User Clips', //not using subtitle here, main frame applies full-width class, which breaks view in this case.
                    isChildState: true,
                    templateUrl: 'components/userProfile/userProfileFeedView.html',
                });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/userProfile/userProfile.js